import { render, staticRenderFns } from "./CadastroPromocaoAgente.vue?vue&type=template&id=6b67273e&scoped=true&class=template&"
import script from "./CadastroPromocaoAgente.vue?vue&type=script&lang=js&"
export * from "./CadastroPromocaoAgente.vue?vue&type=script&lang=js&"
import style0 from "./CadastroPromocaoAgente.vue?vue&type=style&index=0&id=6b67273e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b67273e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCol,VIcon,VRow})
